import { GenericResponse } from '@/types/downloadReports';

import { createAsyncAction } from 'typesafe-actions';

import { FXHeatmapFormValues } from '../components/FXHeatmap/types';

export const updateHeatmapInputs = createAsyncAction(
  'FX_HEATMAP/updateHeatmapInputs/request',
  'FX_HEATMAP/updateHeatmapInputs/success',
  'FX_HEATMAP/updateHeatmapInputs/failure',
)<Partial<FXHeatmapFormValues>, Partial<FXHeatmapFormValues>, string>();

export const downloadFxReportActions = createAsyncAction(
  'FX_HEATMAP/downloadFxReport/request',
  'FX_HEATMAP/downloadFxReport/success',
  'FX_HEATMAP/downloadFxReport/failure',
)<void, GenericResponse, string>();
